import {Injectable} from '@angular/core'

@Injectable()

export class ServiciosRestauracionService {


  tabla = 'rest_servicios_rest';
  data = [];

  constructor() {

    this.data = JSON.parse(localStorage.getItem(this.tabla)) || [];

  }


  get() {

    return this.data;

  }


  set(data) {

    this.data = data;
    localStorage.setItem(this.tabla, JSON.stringify(data));

    return this.data;

  }


  delete() {

    this.data = null;
    localStorage.removeItem(this.tabla);

    return this.data;
  }

}



// WEBPACK FOOTER //
// ./src/services/ServiciosRestauracionService.ts